// Miles recorded on a shift. Odometer readings live in two places: the
// caregiver's own clock row (group shifts / shadow-role side actors) and the
// shift-level columns (1-on-1 primary caregiver). Same precedence rule as the
// API's payroll/stats math: a caregiver's own clock row wins over the
// shift-level reading; the shift-level reading belongs to the primary.

// Trip miles from one odometer-bearing row (shift or clock row).
// null when the trip was never recorded or never closed out.
export function tripMiles(row) {
  if (!row) return null;
  const start = parseFloat(row.odometer_start);
  const end = parseFloat(row.odometer_end);
  if (!isFinite(start) || !isFinite(end) || end < start) return null;
  return Math.round((end - start) * 10) / 10;
}

// Miles one caregiver drove on a shift (their clock row, else the
// shift-level trip when they are the primary caregiver on it).
export function milesForCaregiver(shift, caregiverId) {
  if (!shift || caregiverId == null) return null;
  const ct = (shift.caregiverClockTimes || []).find(
    (r) => Number(r.id_users) === Number(caregiverId),
  );
  if (ct) return tripMiles(ct);
  const me = (shift.caregivers || []).find(
    (c) => Number(c.id) === Number(caregiverId),
  );
  if (!me) return null;
  // Role is nested on raw Sequelize rows, flattened by the by-role payload.
  const role = me.link_shifts_caregiver_users?.role || me.role || "primary";
  if (role !== "primary") return null;
  return tripMiles(shift);
}

// All miles recorded on a shift across caregivers (admin/lead view):
// every clock-row trip, plus the shift-level trip unless the primary
// caregiver has their own clock row (then the row already covers it).
export function totalShiftMiles(shift) {
  if (!shift) return null;
  const clockRows = shift.caregiverClockTimes || [];
  let total = null;
  for (const row of clockRows) {
    const m = tripMiles(row);
    if (m != null) total = (total || 0) + m;
  }
  const primary = (shift.caregivers || []).find(
    (c) =>
      (c.link_shifts_caregiver_users?.role || c.role || "primary") ===
      "primary",
  );
  const primaryHasRow =
    primary &&
    clockRows.some((r) => Number(r.id_users) === Number(primary.id));
  if (!primaryHasRow) {
    const m = tripMiles(shift);
    if (m != null) total = (total || 0) + m;
  }
  return total;
}
